import {
    MEMBER_EDIT_REQUEST,
    MEMBER_EDIT_SUCCESS,
    MEMBER_EDIT_FAIL,
    MEMBER_EDIT_CLEAR,
    MEMBER_ADD_RELATIVES_REQUEST,
    MEMBER_ADD_RELATIVES_SUCCESS,
    MEMBER_ADD_RELATIVES_FAIL,
    MEMBER_UPDATE_RELATIVES_REQUEST,
    MEMBER_UPDATE_RELATIVES_SUCCESS,
    MEMBER_UPDATE_RELATIVES_FAIL,
    MEMBER_HIDE_WIFE_NAME_REQUEST,
    MEMBER_HIDE_WIFE_NAME_SUCCESS,
    MEMBER_HIDE_WIFE_NAME_FAIL,
    MEMBER_DELETE_RELATIVES_REQUEST,
    MEMBER_DELETE_RELATIVES_SUCCESS,
    MEMBER_DELETE_RELATIVES_FAIL,
    MEMBER_DELETE_RELATIVES_CLEAR,
    MEMBER_SEARCH_BY_NAME_REQUEST,
    MEMBER_SEARCH_BY_NAME_SUCCESS,
    MEMBER_SEARCH_BY_NAME_FAIL,
    MEMBER_ADD_RELATIVES_CLEAR,
    MEMBER_CREATE_REQUEST,
    MEMBER_CREATE_SUCCESS,
    MEMBER_CREATE_FAIL,
    MEMBER_CREATE_CLEAR,
    MEMBER_GENERATE_CSV_REQUEST,
    MEMBER_GENERATE_CSV_SUCCESS,
    MEMBER_GENERATE_CSV_FAIL,
    MEMBER_GENERATE_CSV_CLEAR,
    MEMBER_GENERATE_DATA_REQUEST,
    MEMBER_GENERATE_DATA_SUCCESS,
    MEMBER_GENERATE_DATA_FAIL,
    MEMBER_INFO_REQUEST,
    MEMBER_INFO_SUCCESS,
    MEMBER_INFO_FAIL,
    MEMBER_UPLOAD_AVATAR_REQUEST,
    MEMBER_UPLOAD_AVATAR_SUCCESS,
    MEMBER_UPLOAD_AVATAR_FAIL,
    MEMBER_ALL_REQUEST,
    MEMBER_ALL_SUCCESS,
    MEMBER_ALL_FAIL,
    EXPORT_SVG_REQUEST,
    EXPORT_SVG_SUCCESS,
    EXPORT_SVG_FAIL,
    EXPORT_SVG_CLEAR,
    MEMBER_DELETE_REQUEST,
    MEMBER_DELETE_SUCCESS,
    MEMBER_DELETE_FAIL,
    MEMBER_DELETE_CLEAR
} from '../constants/memberConstant'


export const deleteMemberReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_DELETE_REQUEST:
            return {loading:true, error:null}
        case MEMBER_DELETE_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case MEMBER_DELETE_FAIL:
            return {loading:false, error:action.payload}
        case MEMBER_DELETE_CLEAR:
            return {message:null, error:null}
        default:
            return state
    }
}

export const memberNewReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_CREATE_REQUEST:
            return {loading:true, error:null}
        case MEMBER_CREATE_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case MEMBER_CREATE_FAIL:
            return {loading:false, error:action.payload}
        case MEMBER_CREATE_CLEAR:
            return {message:null, error:null}
        default:
            return state
    }
}

export const memberRelativesReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_ADD_RELATIVES_REQUEST:
        case MEMBER_UPDATE_RELATIVES_REQUEST:
        case MEMBER_HIDE_WIFE_NAME_REQUEST:
            return {loading:true, error:null}
        case MEMBER_ADD_RELATIVES_SUCCESS:
        case MEMBER_UPDATE_RELATIVES_SUCCESS:
        case MEMBER_HIDE_WIFE_NAME_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case MEMBER_ADD_RELATIVES_FAIL:
        case MEMBER_UPDATE_RELATIVES_FAIL:
        case MEMBER_HIDE_WIFE_NAME_FAIL:
            return {loading:false, error:action.payload}
        case MEMBER_ADD_RELATIVES_CLEAR:
            return {message:null, error:null}
        default:
            return state
    }
}

export const memberDeleteRelativesReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_DELETE_RELATIVES_REQUEST:
            return {loading:true, error:null}
        case MEMBER_DELETE_RELATIVES_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case MEMBER_DELETE_RELATIVES_FAIL:
            return {loading:false, error:action.payload}
        case MEMBER_DELETE_RELATIVES_CLEAR:
            return {message:null, error:null}
        default:
            return state
    }
}

export const memberEditReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_EDIT_REQUEST:
            return {loading:true, error:null}
        case MEMBER_EDIT_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case MEMBER_EDIT_FAIL:
            return {loading:false, error:action.payload}
        case MEMBER_EDIT_CLEAR:
            return {message:null, error:null}
        default:
            return state
    }
}

export const generateCSVReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_GENERATE_CSV_REQUEST:
            return {loading:true, error:null}
        case MEMBER_GENERATE_CSV_SUCCESS:
            return {loading:false, error:null, csvData:action.payload}
        case MEMBER_GENERATE_CSV_FAIL:
            return {loading:false, error:action.payload}
        case MEMBER_GENERATE_CSV_CLEAR:
            return {error:null, csvData:null}
        default:
            return state
    }
}

export const generateDataReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_GENERATE_DATA_REQUEST:
            return {loading:true, error:null}
        case MEMBER_GENERATE_DATA_SUCCESS:
            return {loading:false, error:null, familyData:action.payload}
        case MEMBER_GENERATE_DATA_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}

export const memberInfoReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_INFO_REQUEST:
            return {loading:true, error:null}
        case MEMBER_INFO_SUCCESS:
            return {loading:false, error:null, info:action.payload}
        case MEMBER_INFO_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}

export const memberUploadAvatarReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_UPLOAD_AVATAR_REQUEST:
            return {loading:true, error:null}
        case MEMBER_UPLOAD_AVATAR_SUCCESS:
            return {loading:false, error:null, message:action.payload}
        case MEMBER_UPLOAD_AVATAR_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}


export const allMembersReducer = (state ={},  action) => {
    switch(action.type) {
        case MEMBER_ALL_REQUEST:
            return {loading:true, error:null}
        case MEMBER_ALL_SUCCESS:
            return {loading:false, error:null, membersData:action.payload}
        case MEMBER_ALL_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}


export const exportSVGReducer = (state = {}, action) => {
    switch(action.type) {
        case EXPORT_SVG_REQUEST:
            return {loading:true, error:null}
        case EXPORT_SVG_SUCCESS:
            return {loading:false, error:null, file:action.payload}
        case EXPORT_SVG_FAIL:
            return {loading:false, error:action.payload}
        case EXPORT_SVG_CLEAR:
            return {error:null, pngData:null}
        default:
            return state
    }
}
export const memberSearchByNameReducer = (state = {}, action) => {
    switch(action.type){
        case MEMBER_SEARCH_BY_NAME_REQUEST:
            return {loading:true, error:null}
        case MEMBER_SEARCH_BY_NAME_SUCCESS:
            return {loading:false, error:null, members:action.payload}
        case MEMBER_SEARCH_BY_NAME_FAIL:
            return {loading:false, error:action.payload}
        default:
            return state
    }
}
